import React, { type FC } from 'react'
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material'

import { IconButton } from '../Button'
import { inputIconStyle } from './TextField'

type VisibilityToggleProps = Readonly<{
    /** Whether the value this toggle controls is currently shown in the clear */
    visible: boolean
    onToggle: () => void
    disabled?: boolean
    /** Accessible name for the action offered while the value is hidden (reveal it) */
    showLabel: string
    /** Accessible name for the action offered while the value is shown (conceal it) */
    hideLabel: string
    'data-testid'?: string
}>

/**
 * An icon button toggling between a value's masked and revealed state (e.g. a password or a
 * write-only secret parameter). Callers own the value/masking itself; this only renders the
 * control and reports the intent to switch state.
 */
export const VisibilityToggle: FC<VisibilityToggleProps> = ({ visible, onToggle, disabled, showLabel, hideLabel, 'data-testid': dataTestId }) => (
    <IconButton data-testid={dataTestId} size="small" variant="ghost" disabled={disabled} onClick={onToggle}>
        {visible ? <VisibilityOffOutlined sx={inputIconStyle} titleAccess={hideLabel} /> : <VisibilityOutlined sx={inputIconStyle} titleAccess={showLabel} />}
    </IconButton>
)
